"use client";
import { createContext, PropsWithChildren, useContext, useMemo } from "react";

import {
  createContentProxy,
  createImageProxy,
  createSliderProxy,
} from "./createResourceProxy";
import { mobileContent, mobileImage, mobileSlider } from "./mobilePayload";
import { Resources } from "./types";

export type MobileResources = Resources<
  typeof mobileContent,
  typeof mobileImage,
  typeof mobileSlider
>;

export const MobileResourceContext = createContext<MobileResources>(undefined!);

export function MobileResourceProvider(
  props: PropsWithChildren<{ resources: MobileResources }>
) {
  return (
    <MobileResourceContext.Provider value={props.resources}>
      {props.children}
    </MobileResourceContext.Provider>
  );
}

export function useMobileContentResource() {
  const content = useContext(MobileResourceContext).content;
  return useMemo(() => createContentProxy(content), [content]);
}

export function useMobileImageResource() {
  const image = useContext(MobileResourceContext).image;
  return useMemo(() => createImageProxy(image), [image]);
}

export function useMobileImageSlider() {
  const slider = useContext(MobileResourceContext).slider;
  return useMemo(() => createSliderProxy(slider), [slider]);
}
